module.exports = __webpack_public_path__ + "img/tp12.79158154.png";